/**
 * Regras de navegação da casca da aplicação.
 */

/** Prefixo das rotas de detalhe de cenário. */
export const SCENARIO_ROUTE_PREFIX = "/scenario";

/**
 * Rota que deve aparecer acesa na navegação.
 *
 * O detalhe de cenário não tem entrada própria: ele é aberto a partir de "Execuções", e
 * manter essa entrada acesa é o que diz ao leitor de onde ele veio e como voltar.
 */
export function activeNavPath(pathname: string): string {
  return isScenarioDetail(pathname) ? "/runs" : pathname;
}

/** Se a rota é o detalhe de um cenário. */
export function isScenarioDetail(pathname: string): boolean {
  return pathname.startsWith(SCENARIO_ROUTE_PREFIX);
}
